export default {
      id: "icon-particulier-usage",
      viewBox: "0 0 25.5 20.5",
      url: "../icon/" + "icons.svg#icon-particulier-usage",
      toString: function () {
        return this.url;
      }
    }